export const socialLinkDic = {
  twitter: "https://twitter.com/playCrystalFun",
  discord: "https://discord.gg/playcrystalfun",
  youtube: "https://www.youtube.com/channel/UCbzGRVcxHYxh0YC_PHTdBqQ",
  twitch: "https://www.twitch.tv/outer_game",
  medium: "https://crystalfun.medium.com/",
  telegram: "https://t.me/OUTER_GAME",
};
